import { useCallback, useEffect } from "react";
import { Box, Button, Dialog, DialogActions, DialogContent,	DialogTitle, IconButton, useTheme, Typography } from "@mui/material";
import { Close } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup/dist/yup";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { IDamage, IDamageSelector } from "../../../models/models";
import { DAMAGE_SELECTOR_FORM_INITIAL_VALUES, DAMAGE_SELECTOR_FORM_VALIDATION_SCHEMA } from "../../config";
import { FormAutocomplete } from "../../../common/form-fields-wrappers";
import {
	checkOutInBufferDataActionTypeState,
	checkOutInPartsAndPositionsState,
	checkOutInSeverityState,
	raFetchedDataState
} from "../../state";
import useOperationTranslation from "../../../../operation/hooks/useOperationTranslation";
import { usePartLabel } from "../damage-list/translations"

const DamageSelector = (props: any) => {
	const { onClose, damage, open } = props;

	const theme = useTheme();
	const {t, i18n} = useTranslation(['network', 'translation']);
	const { t: t2 } = useTranslation('operation');

	const operationTranslation = useOperationTranslation();

	const getPartLabel = usePartLabel();


	// fetch from BE
	const raFetchedData = useRecoilValue(raFetchedDataState);
	const severityList = useRecoilValue(checkOutInSeverityState);
	const partsAndPositionsList = useRecoilValue(checkOutInPartsAndPositionsState);
	const setBufferDataActionDamage = useSetRecoilState(checkOutInBufferDataActionTypeState('damage'));

	const damageSelectorForm = useForm<IDamageSelector>({
		defaultValues: DAMAGE_SELECTOR_FORM_INITIAL_VALUES,
		resolver: yupResolver(
			DAMAGE_SELECTOR_FORM_VALIDATION_SCHEMA
		)
	});

	const handleClose = () => {
		damageSelectorForm.reset();
		onClose();
	};

	const handleAddDamage = (value: any) => {
		const dmg: IDamage = {
			"id": !!damage ? damage.id : null,
			"tenant": raFetchedData.idTenant,
			"part": value?.damage?.part,
			"position":value?.damage?.position,
			"damageFormId": null,
			"severity": value.severity,
			"damageDate": null,
			"createDate": null,
			"updateDate": null,
			"newDamage": true,
			"figureCode": value?.damage?.figureCode,
			"snapshotIdList": []
		}

		setBufferDataActionDamage({
			action: !damage?.id ? 'create' : 'edit',
			data: dmg
		});

		damageSelectorForm.reset();
		onClose();
	};

	useEffect(() => {
		if (!!damage) {
			damageSelectorForm.setValue('damage', damage.damage);
			damageSelectorForm.setValue('severity', damage.severity);
		}
	}, [props]);

	const sortDamageOptions = useCallback((opts: any[]) => {
		switch (i18n.language.toLowerCase()) {
			case "en":
				return opts
					.map((opt: any) => ({ opt, label: getPartLabelWithTranslation(opt) }))
					.sort((a, b) => a.label.localeCompare(b.label))
					.map(({ opt }) => opt);
			default:
				return opts;
		}
	}, [i18n.language])

	const getPartLabelWithTranslation = (damage: IDamage) =>{
		console.log("damage test su selector: ",damage);
		var partCode = damage?.part?.code;
		console.log("partName: ",partCode);
		//partName = partName.replaceAll(" ", '_');
		return t2(`masterDataDamage.partName.${partCode}` as any);
	}


	return (
		<Dialog onClose={handleClose} open={open} fullWidth={true} maxWidth={'xs'}>
			<DialogTitle sx={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
				{t("raCheckOutIn.checkDamage.damageSelector.title")}

				<IconButton onClick={handleClose} sx={{ml: theme.spacing(4), mr: "0px"}}>
					<Close />
				</IconButton>
			</DialogTitle>

			<DialogContent>
				<form>
					<Box>
						<FormAutocomplete<IDamageSelector>
							label={t("raCheckOutIn.checkDamage.damageSelector.labelPart")}
							name={"damage"}
							control={damageSelectorForm.control}
							fullWidth
							options={sortDamageOptions(partsAndPositionsList)}
							//getOptionLabel={getPartLabelWithTranslation}
							getOptionLabel={(opt) => t2(`masterDataDamage.partName.${opt?.part?.code}`) + (opt?.position?.code != "6" ?  " " + t2(`masterDataDamage.positionName.${opt?.position?.code}`) : "")}
							isOptionEqualToValue={(option, value) => option?.part?.code === value?.part?.code}
						/>
					</Box>

					<Box>
						<FormAutocomplete<IDamageSelector>
							label={t("raCheckOutIn.checkDamage.damageSelector.labelSeverity")}
							name={"severity"}
							control={damageSelectorForm.control}
							fullWidth
							options={severityList}
							getOptionLabel={(opt) =>  operationTranslation(`damageList.severityValue.${opt?.toLowerCase()}` as any)}
							isOptionEqualToValue={(option, value) => option === value}
						/>
					</Box>
				</form>
			</DialogContent>

			<DialogActions>
				<Button color={"accent"} onClick={damageSelectorForm.handleSubmit(handleAddDamage)}>
					{t("raCheckOutIn.checkDamage.damageSelector.confirm")}
				</Button>
			</DialogActions>
		</Dialog>
	);
}

export default DamageSelector;
